import { isEqual } from "lodash-es";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { ResourceFieldName } from "@app/util/fieldModel/ResourceFieldModel";
import {
  createSimpleCondition,
  getSimpleConditionForField,
  upsertSimpleConditions,
} from "@app/util/filters/utils";

import ResourceContentType from "./ResourceContentType";
import ResourceContentTypeToFilterTypes from "./ResourceContentTypeToFilterTypes";

const getResourceContentTypeFilter = (
  filter: FilterModel,
  type: ResourceContentType
): FilterModel => {
  return type === ResourceContentType.LINK
    ? upsertSimpleConditions(
        filter,
        createSimpleCondition(ResourceFieldName.URL, FilterOperator.NOT_EMPTY)
      )
    : upsertSimpleConditions(
        filter,
        createSimpleCondition(
          ResourceFieldName.TYPE,
          FilterOperator.IN_ANY,
          ResourceContentTypeToFilterTypes[type]
        )
      );
};

export const getResourceContentTypeFromFilter = (
  filter: FilterModel
): ResourceContentType | undefined => {
  const typeCondition = getSimpleConditionForField(filter, ResourceFieldName.TYPE);
  const urlCondition = getSimpleConditionForField(filter, ResourceFieldName.URL);
  if (urlCondition) {
    return ResourceContentType.LINK;
  }

  if (!typeCondition) {
    return undefined;
  }

  if (typeCondition.operator === FilterOperator.IN_ANY) {
    const entry = Object.entries(ResourceContentTypeToFilterTypes).find(([, values]) =>
      isEqual(values, typeCondition.value)
    )?.[0];
    return entry as ResourceContentType | undefined;
  }

  return undefined;
};

export default getResourceContentTypeFilter;
